// extracted by mini-css-extract-plugin
var _1 = "NavigationFooterStyles-module__navigationFooter___OQ8NH";
var _2 = "NavigationFooterStyles-module__nextButton___nIoSi";
export { _1 as "navigationFooter", _2 as "nextButton" }
